import React, { useState } from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { JobMessageModal } from './JobMessageModal';
interface JobMessageButtonProps {
  jobId: string;
  jobName: string;
  recipientRole: 'contractor' | 'broker' | 'foreman' | 'trucking' | 'driver';
  buttonText?: string;
  className?: string;
  iconOnly?: boolean;
}
export const JobMessageButton: React.FC<JobMessageButtonProps> = ({
  jobId,
  jobName,
  recipientRole,
  buttonText,
  className,
  iconOnly = false
}) => {
  const [showModal, setShowModal] = useState(false);
  return <>
      <button onClick={() => setShowModal(true)} className={className || 'text-blue-600 hover:text-blue-800'} data-id="element-266">
        {iconOnly ? <MessageCircleIcon size={16} data-id="element-267" /> : <>{buttonText || recipientRole}</>}
      </button>
      {showModal && <JobMessageModal jobId={jobId} jobName={jobName} recipientRole={recipientRole} onClose={() => setShowModal(false)} data-id="element-268" />}
    </>;
};